import { TableVariableNode } from '../../editor/nodes/TableVariableNode'
import { TextVariableNode } from '../../editor/nodes/TextVariableNode'
import { useListenVariableNodeChange } from '../hooks/useListenVariableNodeChange'
import { useRemoveNotExistedVariable } from '../hooks/useRemoveNotExistedVariable'
import { useSelectTemplateVariableNode } from '../hooks/useSelectTemplateVariableNode'

export const ContractDesignerEditorTracer = () => {
  // 移除不存在的变量
  useRemoveNotExistedVariable()

  // 监听模板变量节点的变化
  useListenVariableNodeChange(TextVariableNode)
  useListenVariableNodeChange(TableVariableNode)

  // 变量节点的选中处理
  useSelectTemplateVariableNode()

  return null
}
